export interface ICompanyLogoSelect {
    logo_desktop_main: string;
    logo_email: string;
    logo_facebook_share: string;
    logo_mobile_main: string;
    logo_pdf: string;
    logo_position: string;
}
